import * as io from "socket.io-client";
class db {
    constructor(){
        this.socketClient = null;
        this.connectFlag = 0;
        window.__dbTags = window.dbTags ? window.dbTags : {}; 
        
    }

    getLinkId(){
        return this.socketClient ? this.socketClient.id : "";
    }

    connectDb(callback){
        this.socketClient = io.connect();
        this.socketClient.on('connect', function () {
            this.connectFlag = 1;
            this.socketClient.on('message', function(msg){
                switch(msg.head){
                    case "link":
                        alert(msg.message);
                    break;
                    case "backAlarmServer": //监听ps报警在组件中以监听
                        // console.log(msg.message);
                    break;
                    case "init":
                        //服务器主动断开socket连接，原因是服务器正在重启，稍后自动连接
                        setTimeout(function(){
                            window.location.reload();
                        },5000);
                    break;
                    case "forceLogOut":
                        // alert("管理员已经强制这个链接断开");
                    break;
                    default:
                    this.socketmanager.consoleMessage(msg);
                    break;
                }
                if(msg.head == "link"){
                    //服务器主动断开socket连接，原因是连接数超限
                    
                }else if(msg.head == "init"){
                    
                }else{
                    
                }
            }.bind(this));
            this.socketClient.on('error',function(error){
                this.socketClient.disconnect();
            }.bind(this));
            this.socketClient.on('disconnect', function(info) {
                console.log("socket disconnect:" + info);
                this.connectFlag = 0;
            }.bind(this));
            callback();
        }.bind(this));
    }
    
    sendMessage(message,callBackFunc){
        this.socketClient.send(message,callBackFunc);
    }
    realBack(error,realData){
        if(error){
            console.log(error);
            return;
        }
        
        this.updataRealBack(realData.dbVar);
        if(realData.midVar){
            if(window.__systemMidVar){
                for(var p in realData.midVar){
                    if(window.__systemMidVar[p]){
                        //判断，如果不保存下至数据不使用数据库变量
                        if(window.__systemMidVar[p].save == true){
                            window.__systemMidVar[p].value = realData.midVar[p];
                        }
                    }
                }
            }
            
        }
    }

    updataRealBack(parDataArr){
       // x=message.toUpperCase()
        for(var i = 0; i< parDataArr.length;i++){
            try{
                var tagName = parDataArr[i].NAME;
                var nameSplitArr = tagName.split(".");
                var tagObj = __dbTags;
                for(var j = 0; j < nameSplitArr.length;j++){
                    if(tagObj[nameSplitArr[j]]){
                        tagObj = tagObj[nameSplitArr[j]];
                    }else{
                        console.log("服务器返回了未注册点:" + tagName);
                    }
                }
                
                if(parDataArr[i].PV == undefined){
                    tagObj.PV = -9999;
                    tagObj.ERROR = "未从数据源获取到值";
                }else if(tagObj.ERROR != undefined){
                    delete tagObj.ERROR;
                }
                //临时保存原值
                var tempTag = {}
                for(var p1 in tagObj){
                    tempTag[p1] = tagObj[p1];
                }
                //赋值新值
                for(var p in parDataArr[i]){
                    if(parDataArr[i].PV == -9999){
                        parDataArr[i].PV= parseInt(window.textInvalid);
                        parDataArr[i].ERROR = "更改无效值赋值";
                    }
                    tagObj[p] = parDataArr[i][p];
                }
                //新值赋值给本对象的可监听属性（已 __old_ 开头，会被数据改变动作监听）监听属性
                if(tempTag.NAME){
                    // tempTag.NAME 不为0 不是第一次获取到数据
                    for(var p1 in tempTag){
                        if(p1.indexOf("__old_") < 0 && typeof tempTag[p1] !== "function"){
                            tagObj["__old_" + p1] = tempTag[p1];
                        }
                    }
                }
            }catch(e){
                console.log(e);
                continue;
            }
        }
    }

    declareTags(varList){
        function checkRate(nubmer){  
            var re = /^[0-9]/;  //判断是否以数字开头   
            if(re.test(nubmer)) 
                return true;
            var re = /-|~|!|@|#|%|\^|\&|\*|\(|\)|\{|\}|\[|\]|￥|……|（|）|——|=/; //判断是否包含特殊字符
            if(re.test(nubmer))
                return true; 
        }
        
        for(var i = 0; i < varList.length; i++){
            //注册点转成大写
            //varList[i].name = varList[i].name.toUpperCase();
            if(checkRate(varList[i].name)){
                console.warn("错误的数据库名称：" + varList[i].name);
                continue;
            }
            var nameSplitArr = varList[i].name.split(".");
            var varname = varList[i].name;
            var windowVarName = __dbTags;
            for(var j = 0; j < nameSplitArr.length; j++){
                if(windowVarName[nameSplitArr[j]] == undefined){
                    windowVarName[nameSplitArr[j]] = {};
                }
                windowVarName = windowVarName[nameSplitArr[j]]
            }
            //暂时注释掉。否打开新窗口会给所有的值赋初始值
            // for(var p in tagProprety){
            //     if(windowVarName[p])
            //     windowVarName[p]="__defaule";
            // }
        }
    }

    isDbVar(name){
        var nameSplitArr = name.split(".");
        var start = 0; 
        if(nameSplitArr[0] == "__dbTags"){
            start = 1;
        }
        var obj = __dbTags;
        for(var j = start ;j < nameSplitArr.length - 1; j++){
            if(obj[nameSplitArr[j]] == undefined){
                return false;
            }
            obj = obj[nameSplitArr[j]]
        }
        return obj;
    }
}

export default new db();


// WEBPACK FOOTER //
// ./src/js/communication/dbCommunicate.js